import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../lib/utils';

const Pagination = ({
  currentPage,
  totalPages,
  totalRows,
  pageSize,
  onPageChange,
  label = 'results',
  className = '',
}) => {
  const startRow = totalRows === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endRow = Math.min(currentPage * pageSize, totalRows);

  return (
    <div className={cn('flex items-center justify-between py-3 text-xs font-mono text-muted-foreground', className)}>
      <span className="tabular-nums">
        {totalRows === 0 ? `0 ${label}` : `${startRow} - ${endRow} of ${totalRows} ${label}`}
      </span>

      <div className="flex items-center gap-2">
        <button
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="flex h-6 w-6 items-center justify-center text-muted-foreground hover:text-foreground disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeft className="h-3.5 w-3.5" />
        </button>

        <span className="tabular-nums select-none">
          {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className="flex h-6 w-6 items-center justify-center text-muted-foreground hover:text-foreground disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
